module.exports = __webpack_public_path__ + "static/media/institute-16-min.0093ee6f.webp";